import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { TrainingCredentialsExpiringMetricsResponse } from '../_types';
import { QueryParams } from '../TrainingContext';

export async function getExpiringCredentials(
  orgId: string,
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void
): Promise<TrainingCredentialsExpiringMetricsResponse> {
  try {
    const url = `${baseApiUrl()}/insights-center/v1/organizations/${orgId}/training/credentials-expiring-metrics`;
    const response: TrainingCredentialsExpiringMetricsResponse = await fetcher({
      method: 'GET',
      url,
      options: { signal },
    });

    return response;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
}

export default function useExpiringCredentials(
  orgId: string,
  queryParams: QueryParams,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<TrainingCredentialsExpiringMetricsResponse, ServerErrorResponse>(
    ['expiring_credentials', orgId],
    async ({ signal }): Promise<TrainingCredentialsExpiringMetricsResponse> => {
      return getExpiringCredentials(orgId, signal, onError);
    },
    {
      ...options,
      enabled: !!orgId, // Always enabled when orgId is available since it's independent of date range
    }
  );
}
